import React from 'react'

import { Card } from 'components/shared/Card/Card'
import { PaneHeader } from 'components/shared/PaneHeader/PaneHeader'
import { PaneTabsBar } from 'components/shared/PaneTabsBar/PaneTabsBar'

type PaneProps = {
  children?: React.ReactNode
  className?: string
  tagName?: keyof React.JSX.IntrinsicElements
}

type PaneComponent = ((props: PaneProps) => React.JSX.Element) & {
  Header: typeof PaneHeader
  TabsBar: typeof PaneTabsBar
}

export const Pane: PaneComponent = Object.assign(
  ({ children, className, tagName }: PaneProps) => (
    <Card {...{ className, tagName }}>{children}</Card>
  ),
  {
    Header: PaneHeader,
    TabsBar: PaneTabsBar,
  },
)
